import functionCommon from "../common/function";
import { allLeaveRequestConstans } from "../constant/allLeaveRequest.constants";
import CONSTANT from "../constant/constant";
import { allLeaveRequest } from "../services/allLeaveRequest.service";

const _errorCode = CONSTANT.errorCode;
const emptyDataCode = CONSTANT.messageCode.emptyData;

export const getAllLeaveRequest = (data, isSearch = false, isPaging = false) => {
    const from = functionCommon.revertDateFormat(data.dayFrom);
    const to = functionCommon.revertDateFormat(data.dayTo);
    const params = {
        ...data,
        dayFrom: from,
        dayTo: to,
    };

    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        isPaging && dispatch(paging());
        isSearch && dispatch(searching());
        allLeaveRequest.getAllLeaveRequest(params).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    if (res.error_code === emptyDataCode) {
                        dispatch(success([]));
                    }
                    dispatch(success(res.result));
                    break;

                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    window.location = "/error/404";
                    break;
            }
        });
    };

    function success(listRequest) {
        return { type: allLeaveRequestConstans.GET_REQUEST_LIST_SUCCESS, listRequest };
    }
    function searching() {
        return { type: allLeaveRequestConstans.GET_REQUEST_LIST };
    }
    function paging() {
        return { type: allLeaveRequestConstans.GET_REQUEST_LIST_PAGE };
    }
};
